import { Helper } from '../Helper';
export class ArrFindHelper extends Helper {
    constructor(options) {
        super();
        this.each = options.each;
    }
    emit(sb, node, options) {
        sb.emitSysCall(node, 'Neo.Enumerator.Create');
        sb.emitHelper(node, options, sb.helpers.rawEnumeratorFind({
            each: this.each,
        }));
    }
}

//# sourceMappingURL=ArrFindHelper.js.map
